import {
  writable,
  readable,
  derived
} from 'svelte-persistent-store/dist/session';

export const isSuperAdmin = writable('morr-21eqwdsasese', false);
